import React, { createContext, useContext, useState } from 'react';

export const DEFAULT_DRAWER_WIDTH = 800;

interface DrawerWidthContextType {
  drawerWidth: number;
  setDrawerWidth: (width: number) => void;
}

const DrawerWidthContext = createContext<DrawerWidthContextType | undefined>(undefined);

export const useDrawerWidth = () => {
  const context = useContext(DrawerWidthContext);
  if (!context) {
    throw new Error('useDrawerWidth must be used within a DrawerWidthProvider');
  }
  return context;
};

export const DrawerWidthProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
  const [drawerWidth, setDrawerWidth] = useState(DEFAULT_DRAWER_WIDTH);

  return (
    <DrawerWidthContext.Provider value={{drawerWidth, setDrawerWidth}}>
      {children}
    </DrawerWidthContext.Provider>
  );
};
